/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { GetDeliveryResponseDtoParticipationEntitlementsInner } from './get-delivery-response-dto-participation-entitlements-inner';

/**
 * 
 * @export
 * @interface GetDeliveryResponseDto
 */
export interface GetDeliveryResponseDto {
    /**
     * Delivery ID
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'deletedAt': string;
    /**
     * Participation ID this delivery belongs to
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'participationId': string;
    /**
     * Event/Challenge title associated with this delivery
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'eventName'?: string;
    /**
     * Delivery recipient name
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationName': string;
    /**
     * Delivery contact number
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationContactNumber': string;
    /**
     * Destination country
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationCountry': string;
    /**
     * Destination country code
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationCountryCode': string;
    /**
     * Destination province
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationProvince': string;
    /**
     * Destination province code
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationProvinceCode': string;
    /**
     * Destination city
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationCity': string;
    /**
     * Destination city code
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationCityCode': string;
    /**
     * Destination barangay
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationBarangay': string;
    /**
     * Destination barangay code
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationBarangayCode': string;
    /**
     * Destination street address
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationStreet': string;
    /**
     * Additional destination address line (apartment, unit, floor, building)
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationAddressLine2'?: string;
    /**
     * Destination postal code
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationPostalCode': string;
    /**
     * Source API used for destination address data
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationSourceApi': GetDeliveryResponseDtoDestinationSourceApiEnum;
    /**
     * Origin name
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originName'?: string;
    /**
     * Origin contact number
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originContactNumber'?: string;
    /**
     * Origin country
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originCountry'?: string;
    /**
     * Origin country code
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originCountryCode'?: string;
    /**
     * Origin province
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originProvince'?: string;
    /**
     * Origin province code
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originProvinceCode'?: string;
    /**
     * Origin city
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originCity'?: string;
    /**
     * Origin city code
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originCityCode'?: string;
    /**
     * Origin barangay
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originBarangay'?: string;
    /**
     * Origin barangay code
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originBarangayCode'?: string;
    /**
     * Origin street address
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originStreet'?: string;
    /**
     * Origin postal code
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originPostalCode'?: string;
    /**
     * Source API used for origin address data
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'originSourceApi'?: GetDeliveryResponseDtoOriginSourceApiEnum;
    /**
     * Current delivery status
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'status': GetDeliveryResponseDtoStatusEnum;
    /**
     * Tracking number provided by courier
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'trackingNo'?: string;
    /**
     * Tracking link URL
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'trackingLink'?: string;
    /**
     * Delivery courier/service name
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'deliveryCourier'?: string;
    /**
     * Timestamp when delivery was set to on standby
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'onStandbyAt'?: string;
    /**
     * Timestamp when delivery status changed to shipping soon
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'shippingSoonAt'?: string;
    /**
     * Timestamp when delivery went in transit
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'inTransitAt'?: string;
    /**
     * Timestamp when delivery went out for delivery
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'outForDeliveryAt'?: string;
    /**
     * Timestamp when delivery was completed
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'deliveredAt'?: string;
    /**
     * Timestamp when delivery was cancelled
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'cancelledAt'?: string;
    /**
     * Array of image URLs for delivery proof
     * @type {Array<string>}
     * @memberof GetDeliveryResponseDto
     */
    'imageUrls': Array<string>;
    /**
     * Whether the delivery has been confirmed by the user
     * @type {boolean}
     * @memberof GetDeliveryResponseDto
     */
    'isConfirmedByUser': boolean;
    /**
     * Whether finisher shirt is included in this delivery
     * @type {boolean}
     * @memberof GetDeliveryResponseDto
     */
    'shouldIncludeFinisherShirt'?: boolean;
    /**
     * Finisher shirt size if included
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'finisherShirtSize'?: string;
    /**
     * Whether medal is included in this delivery
     * @type {boolean}
     * @memberof GetDeliveryResponseDto
     */
    'shouldIncludeMedal'?: boolean;
    /**
     * List of entitlements included in this delivery
     * @type {Array<GetDeliveryResponseDtoParticipationEntitlementsInner>}
     * @memberof GetDeliveryResponseDto
     */
    'participationEntitlements'?: Array<GetDeliveryResponseDtoParticipationEntitlementsInner>;
    /**
     * Destination recipient name (who will receive the package)
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationRecipient'?: string;
    /**
     * Destination contact number
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationContact'?: string;
    /**
     * Complete destination address (street, address line 2, barangay, city, province, postal code, country)
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'destinationAddress'?: string;
    /**
     * User nickname from participation
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'userNickname'?: string;
    /**
     * User full name from participation
     * @type {string}
     * @memberof GetDeliveryResponseDto
     */
    'userFullName'?: string;
}

export const GetDeliveryResponseDtoDestinationSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type GetDeliveryResponseDtoDestinationSourceApiEnum = typeof GetDeliveryResponseDtoDestinationSourceApiEnum[keyof typeof GetDeliveryResponseDtoDestinationSourceApiEnum];
export const GetDeliveryResponseDtoOriginSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type GetDeliveryResponseDtoOriginSourceApiEnum = typeof GetDeliveryResponseDtoOriginSourceApiEnum[keyof typeof GetDeliveryResponseDtoOriginSourceApiEnum];
export const GetDeliveryResponseDtoStatusEnum = {
    OnStandby: 'on_standby',
    ShippingSoon: 'shipping_soon',
    InTransit: 'in_transit',
    OutForDelivery: 'out_for_delivery',
    Delivered: 'delivered',
    Cancelled: 'cancelled'
} as const;

export type GetDeliveryResponseDtoStatusEnum = typeof GetDeliveryResponseDtoStatusEnum[keyof typeof GetDeliveryResponseDtoStatusEnum];


